<template>
  <div class="container py-4">
    <div v-if="loading" class="text-center py-5 text-muted fw-semibold fs-4">
      <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;"></div>
      <div>Memuat data pembayaran...</div>
    </div>

    <div v-else-if="pembayaranData" class="details-content">

      <div class="vehicle-card-wrapper shadow-sm mb-5">
        <div class="photo-banner-header">Foto Kendaraan</div>
        <div class="vehicle-card-body text-center">
          <div class="media-full-cell">
            <img v-if="fotoKendaraanUrl" :src="fotoKendaraanUrl" class="fullFrame-view" alt="Foto Kendaraan"
              @error="onImageError" />
            <div v-else class="text-center py-5 text-muted bg-light rounded fs-5 w-100">Tidak ada foto bukti kendaraan.
            </div>
          </div>
          <div class="identity-section pt-3">
            <span class="text-uppercase text-muted small fw-bold tracking-wider d-block fs-6">NOMOR PLAT</span>
            <h1 class="plate-number my-2">{{ detailData.plat || pembayaranData.plat_number || '-' }}</h1>

            <!-- Status Badge & Tombol Refresh Jelas -->
            <div class="mt-3 d-flex align-items-center justify-content-center gap-2 flex-wrap">
              <span class="badge px-4 py-2 fs-5 custom-status-badge" :class="statusClass">{{ statusLabel }}</span>

              <button type="button" class="btn-refresh-status" @click="refreshData" :disabled="refreshing || loading">
                <i class="bi bi-arrow-repeat me-1 fs-5" :class="{ 'spin-animation': refreshing }"></i>
                <span>{{ refreshing ? 'Memperbarui...' : 'Refresh Status' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="section-banner-title">Data Pelanggaran</div>
      <div class="table-responsive mb-4">
        <table class="modern-table">
          <tbody>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>No Registrasi</span>
                </div>
              </th>
              <td>{{ detailData.noref || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Jenis Pelanggaran</span>
                </div>
              </th>
              <td>{{ [detailData.report_type, detailData.report_type_code_array].filter(Boolean).join(', ') || '-' }}
              </td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Lokasi Kejadian</span>
                </div>
              </th>
              <td>{{ detailData.jalan || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Waktu Melanggar</span>
                </div>
              </th>
              <td>{{ detailData.waktu || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Waktu Validasi</span>
                </div>
              </th>
              <td>{{ pembayaranData.tanggal_konfirmasi || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Pasal Pelanggaran</span>
                </div>
              </th>
              <td>{{ detailData.pasal || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="section-banner-title">Data Pelanggar</div>
      <div class="table-responsive mb-4">
        <table class="modern-table">
          <tbody>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Nama</span>
                </div>
              </th>
              <td>{{ detailData.nama || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Alamat</span>
                </div>
              </th>
              <td>{{ detailData.alamat || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Email</span>
                </div>
              </th>
              <td>{{ detailKonfirmasi.email || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>No Telepon</span>
                </div>
              </th>
              <td>{{ detailKonfirmasi.no_telp || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>No SIM</span>
                </div>
              </th>
              <td>{{ detailKonfirmasi.no_sim || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Masa Berlaku SIM</span>
                </div>
              </th>
              <td>{{ detailKonfirmasi.masa_berlaku_sim || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>TTL</span>
                </div>
              </th>
              <td>{{ detailKonfirmasi.ttl || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Pekerjaan</span>
                </div>
              </th>
              <td>{{ detailKonfirmasi.pekerjaan || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="section-banner-title">Data Kendaraan</div>
      <div class="table-responsive mb-4">
        <table class="modern-table">
          <tbody>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>TNKB</span>
                </div>
              </th>
              <td>{{ detailData.plat || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Nama Pemilik</span>
                </div>
              </th>
              <td>{{ detailData.NamaPemilik || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Alamat Pemilik</span>
                </div>
              </th>
              <td>{{ detailData.alamat || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Merk / Model / Tipe</span>
                </div>
              </th>
              <td>{{ detailData.merk || '-' }} / {{ detailData.model || '-' }} / {{ detailData.tipe || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Warna</span>
                </div>
              </th>
              <td>{{ detailData.warna || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>No Mesin</span>
                </div>
              </th>
              <td>{{ detailData.no_mesin || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>No Rangka</span>
                </div>
              </th>
              <td>{{ detailData.no_rangka || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Masa Berlaku KIR</span>
                </div>
              </th>
              <td>{{ detailData.tanggal_masa_berlaku || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>JBI</span>
                </div>
              </th>
              <td>{{ detailData.jbi || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="section-banner-title">Data Penindak</div>
      <div class="table-responsive mb-4">
        <table class="modern-table">
          <tbody>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>NIP</span>
                </div>
              </th>
              <td>{{ detailData.nip_validator || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Nama</span>
                </div>
              </th>
              <td>{{ detailData.nama_validator || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Unit Kerja</span>
                </div>
              </th>
              <td>{{ detailData.jabatan_validator || '-' }}</td>
            </tr>
            <tr>
              <th>
                <div class="list-badge-wrapper">
                  <div class="blue-stripe"></div><span>Penindakan</span>
                </div>
              </th>
              <td>ETLE HUB</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="alert-box mt-4"
        v-if="Number(pembayaranData?.status) !== 21 && Number(detailKonfirmasi?.status) !== 21">
        <strong>Pemberitahuan Penting:</strong><br>
        Silahkan lakukan <strong>Pembayaran Titipan</strong> maupun
        <strong>Denda Tilang</strong> sesuai pada Tata Cara Bayar yang tercantum.<br>
        Di luar mekanisme tersebut silahkan <strong>konfirmasi</strong>
        terlebih dahulu dengan petugas terkait.
      </div>

      <template v-if="showPembayaran">
        <div class="section-banner-title">Data Denda Titipan</div>
        <div class="table-responsive mb-4">
          <table class="modern-table">
            <tbody>
              <tr v-if="isSidangLewat && Number(pembayaranData.status) !== 21">
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Informasi Pembayaran</span>
                  </div>
                </th>
                <td>
                  <div class="alert-box mb-0" style="border-left-color: #dc3545;">
                    <strong><i class="bi bi-exclamation-triangle-fill text-danger me-1"></i> Jadwal sidang telah
                      lewat.</strong><br>
                    Kode BRIVA dan nominal Denda Titipan sudah tidak berlaku. Silakan lakukan pengecekan dan pembayaran
                    denda tilang melalui laman resmi e-Tilang Kejaksaan berikut:
                    <a href="https://tilang.kejaksaan.go.id/home" target="_blank" rel="noopener noreferrer"
                      class="fw-bold text-primary text-decoration-underline">
                      https://tilang.kejaksaan.go.id/home
                    </a>
                  </div>
                </td>
              </tr>

              <template v-else-if="!isSidangLewat && Number(pembayaranData.status) !== 21">
                <tr>
                  <th>
                    <div class="list-badge-wrapper">
                      <div class="blue-stripe"></div><span>Kode Bayar BRIVA</span>
                    </div>
                  </th>
                  <td>
                    <div class="d-flex align-items-center gap-3 flex-wrap">
                      <strong class="text-primary fs-4 mb-0">{{ pembayaranData.nomor_briva || '-' }}</strong>
                      <button v-if="pembayaranData.nomor_briva" type="button" class="btn-copy-briva" @click="copyBriva">
                        <i :class="copiedBriva ? 'bi bi-check-circle-fill text-success' : 'bi bi-clipboard me-1'"></i>
                        <span>{{ copiedBriva ? 'Tersalin!' : 'Salin BRIVA' }}</span>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <div class="list-badge-wrapper">
                      <div class="blue-stripe"></div><span>Denda Titipan</span>
                    </div>
                  </th>
                  <td><strong class="text-danger fs-4">{{ formatRupiah(pembayaranData.total_amount) }}</strong></td>
                </tr>
                <tr>
                  <th>
                    <div class="list-badge-wrapper">
                      <div class="blue-stripe"></div><span>Batas Waktu Pembayaran</span>
                    </div>
                  </th>
                  <td>{{ pembayaranData.tanggal_akhir_bayar_briva || '-' }}</td>
                </tr>
              </template>

              <tr v-if="Number(pembayaranData.status) === 21">
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Tanggal Pembayaran</span>
                  </div>
                </th>
                <td>{{ pembayaranData.tanggal_bayar || '-' }}</td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Status Pembayaran</span>
                  </div>
                </th>
                <td>{{ statusLabel }}</td>
              </tr>
              <tr v-if="!isSidangLewat && Number(pembayaranData.status) !== 21">
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div>
                    <span>Aksi</span>
                  </div>
                </th>
                <td>
                  <button type="button" class="btn-primary-custom" @click="bukaModalCaraBayar">
                    Lihat Cara Bayar <i class="bi bi-arrow-right-short"></i>
                  </button>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </template>

      <div class="alert-box mt-4">
        <strong>Pemberitahuan Penting:</strong><br>
        Silakan lakukan pembayaran denda tilang sesuai dengan tata cara yang tercantum. Bagi pelanggar yang memiliki
        <strong>sisa uang titipan denda</strong>, pengembalian (sisa denda) dapat diproses dan diambil secara daring
        melalui
        e-Tilang Kejaksaan
        <a :href="(detailKonfirmasi.nomor_blanko || pembayaranData.nomor_blanko)
          ? 'https://tilang.kejaksaan.go.id/detail/' + (detailKonfirmasi.nomor_blanko || pembayaranData.nomor_blanko)
          : 'https://tilang.kejaksaan.go.id'" target="_blank" rel="noopener noreferrer"
          class="fw-bold text-primary text-decoration-underline">
          klik disini
        </a>
        setelah putusan sidang dikeluarkan.
      </div>

      <template v-if="showPembayaran">
        <div class="section-banner-title">Data Pengadilan</div>
        <div class="table-responsive mb-4">
          <table class="modern-table">
            <tbody>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>No Blanko</span>
                  </div>
                </th>
                <td>{{ pembayaranData.nomor_blanko || '-' }}</td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Link Pengembalian Sisa Denda Tilang</span>
                  </div>
                </th>
                <td>
                  <a v-if="showUrlEtilang"
                    :href="'https://tilang.kejaksaan.go.id/detail/' + (detailKonfirmasi.nomor_blanko || pembayaranData.nomor_blanko)"
                    target="_blank" rel="noopener noreferrer" class="text-primary text-decoration-underline">
                    https://tilang.kejaksaan.go.id/detail/{{ detailKonfirmasi.nomor_blanko ||
                      pembayaranData.nomor_blanko }}
                  </a>
                  <span v-else>-</span>
                </td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Lokasi Sidang</span>
                  </div>
                </th>
                <td>{{ detailKonfirmasi.nama_pengadilan || '-' }}</td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Tanggal Sidang</span>
                  </div>
                </th>
                <td>{{ detailKonfirmasi.tanggal_sidang || '-' }}</td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Keputusan Denda</span>
                  </div>
                </th>
                <td>{{ detailKonfirmasi.keputusan_denda || '-' }}</td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Biaya Perkara</span>
                  </div>
                </th>
                <td>{{ detailKonfirmasi.biaya_perkara || '-' }}</td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>No. Putusan Sidang</span>
                  </div>
                </th>
                <td>{{ detailKonfirmasi.nomor_putusan_sidang || '-' }}</td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Hakim</span>
                  </div>
                </th>
                <td>{{ detailKonfirmasi.hakim || '-' }}</td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div><span>Panitera</span>
                  </div>
                </th>
                <td>{{ detailKonfirmasi.panitera || '-' }}</td>
              </tr>
              <tr>
                <th>
                  <div class="list-badge-wrapper">
                    <div class="blue-stripe"></div>
                    <span>Aksi Surat</span>
                  </div>
                </th>

                <td>
                  <button type="button" class="btn-success-custom" @click="downloadBlanko">
                    <i class="bi bi-download me-1"></i>
                    Buka / Download PDF
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </template>

      <div class="action-group mt-4 mb-5">
        <button type="button" class="btn btn-outline-secondary px-4 py-2" @click="kembaliKeKonfirmasi">
          <i class="bi bi-arrow-left"></i> Kembali
        </button>
      </div>

    </div>

    <div class="modal fade" id="caraBayarModal" ref="caraBayarModal" tabindex="-1" aria-labelledby="caraBayarModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content border-0 shadow">
          <div class="modal-header text-white" style="background-color: #24378b;">
            <h5 class="modal-title fw-bold" id="caraBayarModalLabel">
              <i class="bi bi-wallet2 me-2"></i> Tata Cara Pembayaran BRIVA
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body p-4">
            <div
              class="alert alert-info border-0 bg-light-blue text-dark mb-4 d-flex align-items-center justify-content-between flex-wrap gap-2">
              <div>
                <i class="bi bi-info-circle-fill text-primary me-2"></i>
                Pastikan Nomor BRIVA Anda adalah: <strong class="text-primary fs-5">{{ pembayaranData.nomor_briva || '-'
                }}</strong>
                dengan total nominal sebesar <strong class="text-danger fs-5">{{
                  formatRupiah(pembayaranData.total_amount)
                }}</strong>.
              </div>

              <button v-if="pembayaranData.nomor_briva" type="button"
                class="btn btn-sm btn-primary px-3 fw-semibold d-inline-flex align-items-center gap-1"
                @click="copyBriva">
                <i :class="copiedBriva ? 'bi bi-check-lg' : 'bi bi-clipboard'"></i>
                <span>{{ copiedBriva ? 'Tersalin!' : 'Salin' }}</span>
              </button>
            </div>

            <div class="accordion modern-accordion" id="accordionCaraBayar">
              <div class="accordion-item mb-2 border rounded">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    <span class="badge bg-primary me-2">1</span> Melalui Aplikasi BRImo
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                  data-bs-parent="#accordionCaraBayar">
                  <div class="accordion-body">
                    <ol class="list-step mb-0">
                      <li>Buka aplikasi <strong>BRImo</strong> di smartphone Anda dan lakukan login.</li>
                      <li>Pilih menu <strong>BRIVA</strong> pada halaman utama.</li>
                      <li>Pilih <strong>Tambah Transaksi Baru</strong>.</li>
                      <li>Masukkan Nomor BRIVA Anda: <code class="fs-6 text-dark fw-bold">{{ pembayaranData.nomor_briva ||
                        '-' }}</code>, lalu klik <strong>Lanjutkan</strong>.</li>
                      <li>Periksa detail pembayaran (Nama & Nominal Denda). Jika sudah sesuai, klik
                        <strong>Bayar</strong>.
                      </li>
                      <li>Masukkan <strong>PIN BRImo</strong> Anda untuk menyelesaikan transaksi.</li>
                    </ol>
                  </div>
                </div>
              </div>

              <div class="accordion-item mb-2 border rounded">
                <h2 class="accordion-header" id="headingTwo">
                  <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    <span class="badge bg-primary me-2">2</span> Melalui ATM BRI
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                  data-bs-parent="#accordionCaraBayar">
                  <div class="accordion-body">
                    <ol class="list-step mb-0">
                      <li>Masukkan kartu ATM BRI dan PIN Anda.</li>
                      <li>Pilih menu <strong>Transaksi Lain</strong>, kemudian pilih menu <strong>Pembayaran</strong>.
                      </li>
                      <li>Pilih menu <strong>Lainnya</strong>, lalu pilih <strong>BRIVA</strong>.</li>
                      <li>Masukkan Nomor BRIVA Anda: <code class="fs-6 text-dark fw-bold">{{ pembayaranData.nomor_briva ||
                        '-' }}</code>, kemudian tekan <strong>Benar</strong>.</li>
                      <li>Layar ATM akan menampilkan informasi konfirmasi denda. Jika data sudah benar, pilih
                        <strong>Ya</strong>.
                      </li>
                      <li>Ambil struk ATM sebagai bukti pembayaran yang sah.</li>
                    </ol>
                  </div>
                </div>
              </div>

              <div class="accordion-item mb-2 border rounded">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <span class="badge bg-primary me-2">3</span> Melalui Agen BRILink
                  </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                  data-bs-parent="#accordionCaraBayar">
                  <div class="accordion-body">
                    <ol class="list-step mb-0">
                      <li>Kunjungi Agen BRILink terdekat dari lokasi Anda.</li>
                      <li>Sampaikan kepada petugas agen bahwa Anda ingin melakukan pembayaran <strong>BRIVA</strong>.
                      </li>
                      <li>Berikan Nomor BRIVA Anda kepada agen: <code class="fs-6 text-dark fw-bold">{{
                        pembayaranData.nomor_briva || '-' }}</code>.</li>
                      <li>Agen akan melakukan validasi transaksi di mesin EDC. Pastikan nama pelanggar dan nominal denda
                        sesuai.</li>
                      <li>Lakukan pembayaran tunai atau gesek kartu debit Anda pada agen.</li>
                      <li>Terima struk bukti pembayaran dari Agen BRILink.</li>
                    </ol>
                  </div>
                </div>
              </div>

              <div class="accordion-item mb-2 border rounded">
                <h2 class="accordion-header" id="headingFour">
                  <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    <span class="badge bg-primary me-2">4</span> Transfer dari Bank Lain (ATM / Mobile Banking)
                  </button>
                </h2>
                <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                  data-bs-parent="#accordionCaraBayar">
                  <div class="accordion-body">
                    <ol class="list-step mb-0">
                      <li>Buka aplikasi Mobile Banking atau kunjungi ATM Bank lain pilihan Anda.</li>
                      <li>Pilih menu <strong>Transfer ke Bank Lain</strong>.</li>
                      <li>Pilih Bank Tujuan: <strong>Bank BRI</strong> (Kode Bank: <code>002</code>).</li>
                      <li>Pada nomor rekening tujuan, masukkan nomor BRIVA Anda: <code class="fs-6 text-dark fw-bold">{{
                        pembayaranData.nomor_briva || '-' }}</code>.</li>
                      <li>Masukkan nominal transfer tepat sebesar: <strong>{{ formatRupiah(pembayaranData.total_amount)
                          }}</strong>. <span class="text-danger fw-semibold">(Harus pas, tidak boleh
                          lebih/kurang)</span>.
                      </li>
                      <li>Ikuti instruksi selanjutnya di layar untuk menyelesaikan konfirmasi transfer.</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer bg-light border-top-0">
            <button type="button" class="btn btn-secondary px-4" data-bs-dismiss="modal">Tutup</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getCekPembayaran, postDetailsKonfirmasi, getDetailKonfirmasi } from "./api.js";
import { Modal } from 'bootstrap';

export default {
  data() {
    return {
      loading: false,
      refreshing: false,
      copiedBriva: false,
      pembayaranData: {},
      detailData: {},
      detailKonfirmasi: {}
    };
  },
  async mounted() {
    await this.loadData();
    if (this.pembayaranData && Object.keys(this.pembayaranData).length > 0) {
      this.$emit("data-loaded");
    }
  },

  computed: {
    isSidangLewat() {
      const tgl = this.detailKonfirmasi?.tanggal_sidang;


      if (!tgl || tgl === '-') return false;

      const parsed = this.parseTanggalSidang(tgl);
      if (!parsed) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return parsed < today;
    },

    showUrlEtilang() {
      const statusVal = String(this.pembayaranData?.status || this.detailKonfirmasi?.status);
      const isSudahBayar = statusVal === '21';

      const isValid = (val) => {
        if (!val) return false;
        const cleanVal = String(val).trim();
        return cleanVal !== '' && cleanVal !== '-' && cleanVal !== '0';
      };

      const item = this.detailKonfirmasi || {};

      const hasDenda = isValid(item.keputusan_denda);
      const hasBlanko = isValid(item.nomor_blanko || this.pembayaranData?.nomor_blanko);

      return isSudahBayar && hasDenda && hasBlanko;
    },

    showPembayaran() {
      return [20, 21, 30].includes(Number(this.pembayaranData?.status));
    },

    statusLabel() {
      const status = Number(this.pembayaranData?.status);
      switch (status) {
        case 21: return "SUDAH BAYAR";
        case 20: return "BELUM BAYAR";
        case 11: return "TERKONFIRMASI";
        case 30: return "TERBLOKIR";
        default: return "STATUS TIDAK DIKETAHUI";
      }
    },

    statusClass() {
      const status = Number(this.pembayaranData?.status);
      switch (status) {
        case 21: return "bg-success text-white";
        case 20: return "bg-warning text-dark";
        case 30: return "bg-danger text-white";
        default: return "bg-primary text-white";
      }
    },

    fotoKendaraanUrl() {
      const url = this.detailData?.bukti_foto;
      if (!url) return null;
      if (url.includes("api-provider-jid.jasamarga.com")) {
        return `${process.env.VUE_APP_API_URL}/etle/admin-etle/proxy-image.php?url=` + encodeURIComponent(url);
      }
      return url;
    },
  },

  methods: {
    parseTanggalSidang(str) {
      if (!str) return null;

      let d = new Date(String(str).replace(' ', 'T'));
      if (!isNaN(d.getTime())) return d;

      const match = String(str).match(/(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/);
      if (match) {
        const [, day, month, year] = match;
        d = new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`);
        if (!isNaN(d.getTime())) return d;
      }

      return null;
    },
    async copyBriva() {
      const brivaNum = this.pembayaranData?.nomor_briva;
      if (!brivaNum) return;

      try {
        await navigator.clipboard.writeText(brivaNum);
        this.copiedBriva = true;
        setTimeout(() => {
          this.copiedBriva = false;
        }, 2000);
      } catch (err) {
        console.error("Gagal menyalin nomor BRIVA:", err);
      }
    },

    async refreshData() {
      await this.loadData(true);
    },

    async loadData(isRefresh = false) {
      if (isRefresh) {
        this.refreshing = true;
      } else {
        this.loading = true;
      }

      const noRef = this.$route.query.ref_number;
      const noPlat = this.$route.query.plates;

      try {
        const formData = new FormData();
        formData.append("no_ref", noRef);
        formData.append("no_plat", noPlat);

        const [pembayaranResponse, detailResponse, detailKonfirmasiResponse] = await Promise.all([
          getCekPembayaran(noRef, noPlat),
          postDetailsKonfirmasi(formData),
          getDetailKonfirmasi(noRef, noPlat)
        ]);

        if (pembayaranResponse?.data?.status) {
          this.pembayaranData = pembayaranResponse.data.data;
        }
        if (Array.isArray(detailResponse.data) && detailResponse.data.length > 0) {
          this.detailData = detailResponse.data[0];
        }
        if (detailKonfirmasiResponse?.data?.status) {
          this.detailKonfirmasi = detailKonfirmasiResponse.data.data;
        }
      } catch (err) {
        console.error("Gagal memuat/refresh data:", err);
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },

    async downloadBlanko() {
      const refNumber = this.$route.query.ref_number;
      const plates = this.$route.query.plates;

      if (!refNumber || !plates) {
        alert("Data blanko tidak ditemukan.");
        return;
      }

      const url =
        `${process.env.VUE_APP_API_URL}/etle/admin-etle/serve_blanko.php` +
        `?ref_number=${encodeURIComponent(refNumber)}` +
        `&plates=${encodeURIComponent(plates)}`;

      window.open(url, "_blank");
    },

    bukaModalCaraBayar() {
      const modalElement = document.getElementById('caraBayarModal') || this.$refs.caraBayarModal;
      if (modalElement) {
        const modalInstance = Modal.getOrCreateInstance(modalElement);
        modalInstance.show();
      } else {
        console.error("Elemen #caraBayarModal tidak ditemukan di DOM.");
      }
    },
    onImageError(e) {

    },
    async loadData() {
      this.loading = true;
      const noRef = this.$route.query.ref_number;
      const noPlat = this.$route.query.plates;

      try {
        const formData = new FormData();
        formData.append("no_ref", noRef);
        formData.append("no_plat", noPlat);

        const [pembayaranResponse, detailResponse, detailKonfirmasiResponse] = await Promise.all([
          getCekPembayaran(noRef, noPlat),
          postDetailsKonfirmasi(formData),
          getDetailKonfirmasi(noRef, noPlat)
        ]);

        if (pembayaranResponse?.data?.status) {
          this.pembayaranData = pembayaranResponse.data.data;
        }
        if (Array.isArray(detailResponse.data) && detailResponse.data.length > 0) {
          this.detailData = detailResponse.data[0];
        }
        if (detailKonfirmasiResponse?.data?.status) {
          this.detailKonfirmasi = detailKonfirmasiResponse.data.data;
        }
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    kembaliKeKonfirmasi() {
      this.$router.push({ name: "Konfirmasi" });
    },
    formatRupiah(value) {
      if (!value || value === "-") return "Rp 0";
      const amount = Number(value);
      if (isNaN(amount)) return "Rp 0";
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(amount);
    },
    copyText(text, label = "Teks") {
      if (!text) return;
      navigator.clipboard.writeText(text);
      this.toastMessage = `${label} disalin!`;
      Toast.getOrCreateInstance(this.$refs.copyToast, { delay: 2000 }).show();

      this.copiedBriva = true;
      setTimeout(() => {
        this.copiedBriva = false;
      }, 2000);
    }
  },
};
</script>

<style scoped>
@media (min-width: 1200px) {
  .blanko-breakout-container {
    width: 1350px;
    max-width: 95vw;
    margin-left: calc(-1 * (1350px - 100%) / 2) !important;
  }
}

.blanko-embed-wrapper {
  background-color: #f8fafc;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-top: none !important;
  border-radius: 0 0 8px 8px !important;
}

.legacy-radius {
  border-radius: 8px 8px 0 0 !important;
}

.blanko-embed-wrapper embed {
  display: block;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.btn-success-custom {
  background-color: #198754;
  color: #ffffff;
  border: none;
  padding: 10px 22px;
  border-radius: 6px;
  font-weight: 600;
  transition: background-color 0.2s ease;
}

.btn-success-custom:hover {
  background-color: #157347;
  color: #ffffff;
}

.vehicle-card-wrapper {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.photo-banner-header {
  background-color: #24378b;
  color: #ffffff;
  font-weight: bold;
  font-size: 16px;
  padding: 14px 20px;
  text-align: left;
  letter-spacing: 0.5px;
}

.vehicle-card-body {
  padding: 30px 40px;
}

.media-full-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
  width: 100%;
}

.fullFrame-view {
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 550px;
  object-fit: contain;
  border-radius: 4px;
}

.plate-number {
  font-size: 4rem;
  font-weight: 800;
  letter-spacing: 2px;
  color: #1a253c;
  margin: 10px 0;
}

.custom-status-badge {
  font-weight: 700;
  font-size: 1.15rem !important;
  text-transform: uppercase;
  border-radius: 6px;
  padding: 10px 35px !important;
}

.list-badge-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.blue-stripe {
  width: 5px;
  height: 22px;
  background-color: #24378b;
  border-radius: 4px;
  flex-shrink: 0;
}

.section-banner-title {
  background-color: #24378b;
  color: #ffffff !important;
  font-weight: bold;
  font-size: 18px;
  padding: 14px 20px;
  border-radius: 8px;
  letter-spacing: 0.5px;
  margin-top: 35px;
  margin-bottom: 5px;
}

.btn-primary-custom {
  background-color: #24378b;
  color: #ffffff;
  border: none;
  padding: 10px 22px;
  border-radius: 6px;
  font-weight: 600;
  transition: background-color 0.2s ease;
}

.btn-primary-custom:hover {
  background-color: #1b2a6b;
  color: #ffffff;
}

.alert-box {
  background-color: #f8fafc;
  border-left: 4px solid #24378b;
  padding: 15px 20px;
  border-radius: 0 8px 8px 0;
  color: #334155;
  font-size: 15px;
  line-height: 1.6;
}

.modern-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 12px;
}

.modern-table th,
.modern-table td {
  padding: 16px 20px;
  vertical-align: middle;
  font-size: 18px;
}

.modern-table th {
  width: 35%;
  text-align: left;
  font-weight: normal;
  color: #1e293b;
  background: #f1f5fb;
  border-radius: 10px 0 0 10px;
  border-left: 1px solid #cbd5e1;
  border-top: 1px solid #cbd5e1;
  border-bottom: 1px solid #cbd5e1;
}

.modern-table td {
  color: #000000;
  background: #ffffff;
  border-radius: 0 10px 10px 0;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  border-right: 1px solid #cbd5e1;
  border-top: 1px solid #cbd5e1;
  border-bottom: 1px solid #cbd5e1;
}

.btn-refresh-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  color: #24378b;
  border: 1.5px solid #24378b;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
}

.btn-refresh-status:hover:not(:disabled) {
  background-color: #24378b;
  color: #ffffff;
  box-shadow: 0 4px 8px rgba(36, 55, 139, 0.2);
  transform: translateY(-1px);
}

.btn-refresh-status:active:not(:disabled) {
  transform: translateY(0);
}

.btn-refresh-status:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  border-color: #94a3b8;
  color: #64748b;
}

.spin-animation {
  display: inline-block;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Styling Tombol Copy BRIVA */
.btn-copy-briva {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #f1f5f9;
  color: #24378b;
  border: 1px solid #cbd5e1;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-copy-briva:hover {
  background-color: #24378b;
  color: #ffffff;
  border-color: #24378b;
}

.btn-copy-briva:hover .text-success {
  color: #ffffff !important;
}

.bg-light-blue {
  background-color: #eff6ff;
}

@media (max-width: 768px) {
  .vehicle-card-body {
    padding: 15px;
  }

  .plate-number {
    font-size: 2.5rem;
  }
}
</style>